Librarian.UserProfileWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["loadProfile", "loadProfileImage", "loadLogoImage", "saveProfile", "uploadPhoto", "uploadLogo", "removeUserProfile"],

    options: {
        id: "userProfileWindow",
        width: 500,
        height: 400,
        padding: Librarian.event.htmlEditor ? {
            top: 5,
            right: 5,
            bottom: 0,
            left: 5
        } : {}
    },

    uploadWindow: null,

    initialize: function (options) {
        this.setOptions(options);

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("profile_title");

        this.options.contentURL = Librarian.profile.custom
            ? Librarian.path.getLibraryPath()
            : (Librarian.path.getLayoutsPath() + "pages/");
        this.options.contentURL += "userprofile.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.parent();
        this.setupElements();

        var size = this.getElement("size"),
            showPasswordChange = !Librarian.profile.disableChangePassword && ((Librarian.sessionType != Librarian.Session.sessionTypes.sso) || Librarian.profile.allowSSOPassword);
        if (size) {
            this.options.width = size.getAttribute("data-width").toInt();
            this.options.height = size.getAttribute("data-height").toInt();
        }
        else if (!Librarian.profile.userPhoto) {
            this.options.height -= 60;
            this.options.width -= 60;

            if (!showPasswordChange)
                this.options.width -= 140;
        } else if (!Librarian.profile.userLogo) {
            this.options.height -= 50;
            var el = this.getElement("userProfilePhotoContainer");
            el.setStyle('height', el.getStyle('height').toInt() - 50);
        }

        var itemEl = this.getElement("userProfileUploadButton");
        if (itemEl) {
            itemEl.addOnClick(this.uploadPhoto);
        }

        itemEl = this.getElement("userLogoUploadButton");

        if (itemEl) {
            if (Librarian.profile.userLogo) {
                itemEl.addOnClick(this.uploadLogo);
            } else {
                itemEl.hide();
            }
        }

        itemEl = this.getElement("userProfilePasswordButton");
        if (itemEl) {
            // SSO users don't have passwords
            if (showPasswordChange) {
                itemEl.addOnClick(function () {
                    new Librarian.ChangePasswordWindow().show();
                });
            }
            else
                itemEl.destroy();
        }

        itemEl = this.getElement("userProfileEditSignatureButton");
        if (itemEl && Librarian.event.editSignature) {
            itemEl.show("inline-block");
            itemEl.addOnClick(this.editSignature);
        }

        itemEl = this.getElement("userProfileCancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("userProfileSaveButton");
        if (itemEl)
            itemEl.addOnClick(this.saveProfile);

        itemEl = this.getElement("userProfileEmail");
        if (itemEl) {
            // Cancel key presses so that backspace doesn't pass on to the browser, causing it to go to the previous page
            itemEl.addEvent("keydown", function () {
                return false;
            });
        }

        this.initEmailGreetingHelp();

        //height is the difference between the photo and the form or 0
        this.loadProfileImage();
        this.loadLogoImage();
        this.loadProfile();

        //Save height to resize later
        this.resize({
            width: this.options.width,
            height: this.options.height
        });
    },

    loadProfile: function () {
        var userInfo = Librarian.userInfo;

        var formEl = this.getElement("userProfileForm");
        if (!formEl)
            return;

        // Populate drop downs
        var selectEls = formEl.getElements("select[name]");
        selectEls.forEach(function (selectEl) {
            var list = Librarian.UserProfileWindow.attributes[selectEl.name];
            if (typeOf(list) == "array") {
                list.forEach(function (value) {
                    new Element("option", { text: value }).inject(selectEl);
                });
            }
        });

        if (formEl.FirstName)
            formEl.FirstName.value = userInfo.FirstName;

        if (formEl.LastName)
            formEl.LastName.value = userInfo.LastName;

        if (formEl.Email)
            formEl.Email.value = userInfo.Email;

        if (formEl.PhoneNumber)
            formEl.PhoneNumber.value = userInfo.PhoneNumber;

        // Custom user attributes
        var attributes = formEl.getElements(".profile-attribute");
        attributes.forEach(function (attributeEl) {
            var value = Librarian.Utils.getAttributeFromArray(Librarian.userInfo.Attributes, attributeEl.name);
            if (value)
                Librarian.Utils.setElementValue(attributeEl, value);
        });
    },

    loadProfileImage: function () {
        var contEl = this.getElement("userPhotoCont"),
            itemEl = this.getElement("userPhoto");
        if (contEl && itemEl && Librarian.profile.userPhoto)
            contEl.show();
        else
            return;

        var deleteEl = this.getElement("deleteUserProfile");
        if (deleteEl)
            deleteEl.show();
        else {
            deleteEl = new Element("img", {
                "src": Librarian.path.getImagesPath() + "delete.gif",
                "style": "position:absolute; top:0;right:0",
                "id": "deleteUserProfile",
                "class": "pointer"
            }).injectInside(contEl);
            deleteEl.addOnClick(this.removeUserPhoto, this);
        }

        itemEl.addEvent("error", function () {
            itemEl.removeEvents("error");
            itemEl.src = Librarian.path.getFullPath(Librarian.path.root + "/img/NoPhoto.jpg");
            if (deleteEl)
                deleteEl.hide();
        });
        itemEl.src = Librarian.path.getDownloadUrl() + "mode=dsf&format=image/jpeg&ftype=" + Librarian.SupportFiles.supportFileTypes.userProfileImage + '&' + new Date().getTime();
    },

    loadLogoImage: function () {
        var contEl = this.getElement("userLogoCont"),
            itemEl = this.getElement("userLogo");
        if (contEl && itemEl && Librarian.profile.userLogo) {
            contEl.show();
        } else {
            return;
        }

        var deleteEl = this.getElement("deleteUserLogo");
        if (deleteEl) {
            deleteEl.show();
        } else {
            deleteEl = new Element("img",
                {
                    "src": Librarian.path.getImagesPath() + "delete.gif",
                    "style": "position:absolute; top:0;right:0",
                    "id": "deleteUserLogo",
                    "class": "pointer"
                }).injectInside(contEl);
            deleteEl.addOnClick(this.removeUserLogo, this);
        }

        itemEl.addEvent("error", function () {
            itemEl.removeEvents("error");
            itemEl.src = Librarian.path.getFullPath(Librarian.path.root + "/img/PersonalLogo_NoLogo.png");
            if (deleteEl) {
                deleteEl.hide();
            }
        });
        itemEl.src = Librarian.path.getDownloadUrl() + "mode=dnld&format=image/jpeg&cattype=2&fname=PersonalLogoImage&" + new Date().getTime();
    },

    removeUserLogo: function () {
        Librarian.Utils.getFileID(Librarian.userInfo.Email + "_PersonalLogoImage",
            function (id) {
                if (id) {
                    Librarian.Utils.deleteFile(id, function () {
                        this.loadLogoImage();
                    }.bind(this));
                }
            }.bind(this), null, true);
    },

    removeUserPhoto: function () {
        Librarian.SupportFiles.getSupportFiles(Librarian.SupportFiles.supportFileTypes.userProfileImage, null, null,
            function (json) {
                var data;
                if (json.length > 0)
                    data = json[0].SupportFileId;
                else
                    data = json.SupportFileId;
                if (data) {
                    Librarian.SupportFiles.deleteFile(data, function () {
                        this.loadProfileImage();
                    }.bind(this));
                }
            }.bind(this));
    },

    saveProfile: function () {
        var userInfo = this.getProfileInfo(),
            url = Librarian.path.getMethodUrl("setupi") + "&in=ujson&out=ujson";

        new Librarian.Request.JSON({
            url: url,
            method: "post",
            data: Base64.encode(JSON.stringify(userInfo)),
            onSuccess: function (json) {
                Librarian.Utils.notification(Librarian.Lang.getString("profile_saved"), null, 3000);
                Librarian.userInfo = json;
                this.close();
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        }).send();
    },

    getProfileInfo: function () {
        var userInfo = {
            attributes: []
        };

        var formEl = this.getElement("userProfileForm");
        if (!formEl)
            return userInfo;

        if (formEl.FirstName)
            userInfo.FirstName = formEl.FirstName.value;

        if (formEl.LastName)
            userInfo.LastName = formEl.LastName.value;

        if (formEl.Email)
            userInfo.Email = formEl.Email.value;

        if (formEl.PhoneNumber)
            userInfo.PhoneNumber = formEl.PhoneNumber.value;

        // Custom user attributes
        var attributes = formEl.getElements(".profile-attribute");
        attributes.forEach(function (attributeEl) {
            var value = Librarian.Utils.getElementValue(attributeEl);
            if (attributeEl.name) {
                userInfo.attributes.push({
                    name: attributeEl.name,
                    value: value || ""
                });
            }
        });

        return userInfo;
    },

    uploadPhoto: function () {
        var fid = '';
        Librarian.SupportFiles.getSupportFiles(Librarian.SupportFiles.supportFileTypes.userProfileImage, null, null, function (JSON) {
            var data;
            if (JSON.length > 0)
                data = JSON[0].SupportFileId;
            else
                data = JSON.SupportFileId;
            if (data)
                fid = "&fid=" + data;

            this.uploadWindow = new Librarian.FileUploadWindow({
                acceptType: "image/*",
                successText: Librarian.Lang.getString("profile_upload_success"),
                uploadUrl: Librarian.path.getSupportUrl("uplfile") + "&replace=1&ftype=" + Librarian.SupportFiles.supportFileTypes.userProfileImage + fid,
                onSuccess: function () {
                    this.loadProfileImage();
                }.bind(this)
            }).show();
        }.bind(this));
    },

    uploadLogo: function () {
        var self = this;
        this.uploadWindow = new Librarian.Html5UploadWindow({
            acceptType: "image/tiff, image/jpeg, image/png",
            allowedFileTypes: ["image/tiff", "image/jpeg", "image/png"],
            fileName: "PersonalLogoImage",
            height: 165,
            maxImageHeight: 600,
            maxImageWidth: 600,
            infoText: Librarian.Lang.getString("uploader_personal_logo_description"),
            complete: function () {
                Librarian.Utils.message(Librarian.Lang.getString("profile_upload_success"), null, 3000);
                window.setTimeout(function () {
                        //Hack because complete function is firing before file is saved
                        self.loadLogoImage();
                    },
                    3000);
            }.bind(this)
        }).show();
    },

    editSignature: function () {
        var initialValue = Librarian.Utils.getAttributeFromArray(Librarian.userInfo.Attributes, "Email_Signature"),
            options = {
                title: Librarian.Lang.getString("deeplink_edit_signature_title"),
                initialValue: initialValue,
                onSubmit: function (value) {
                    var url = Librarian.path.getMethodUrl("setuat") + "&out=ujson&name=Email_Signature";
                    new Librarian.Request.JSON({
                        url: url,
                        method: "post",
                        data: Base64.encode(value),
                        onFailure: Librarian.Utils.onFailure,
                        onSuccess: function (attributes) {
                            Librarian.Utils.notification(Librarian.Lang.getString("deeplink_edit_signature_changed"));
                            Librarian.userInfo.Attributes = attributes;

                            var messageEl = this.getElement("messageBox");
                            if (messageEl && messageEl.editor) {
                                tinymce.each(messageEl.editor.dom.select("#email-signature"), function (n) {
                                    n.innerHTML = value;
                                });
                            }
                        }.bind(this)
                    }).send();
                }.bind(this)
            };
        (Librarian.event.htmlEditor ? new Librarian.HTMLInputWindow(options) : new Librarian.InputWindow(options)).show();
    },

    emailGreetingOptions:
        "<div class='emailGreetingHelp'>" +
        "<h2>Email Greeting:</h2>" +
        "<p>" +
        "<div>This greeting will be used " +
        "as your default email greeting " +
        "when sharing to a contact.</div>" +
        "</p>" +
        "<h3>Recipient Placeholders:</h3>" +
        "<p>Click on a recipient property to " +
        "use them in your greeting.<p>" +
        "<div class='pure-g'>" +
        "<div class='pure-u-1-2'><a href='#' class='emailGreetingPlaceholder'>First Name</a></div>" +
        "<div class='pure-u-1-2 emailGreetingValue'>{RecipientInfo.FirstName}</div>" +
        "<div class='pure-u-1-2'><a href='#' class='emailGreetingPlaceholder'>Last Name</a></div>" +
        "<div class='pure-u-1-2 emailGreetingValue'>{RecipientInfo.LastName}</div>" +
        "<div class='pure-u-1-2'><a href='#' class='emailGreetingPlaceholder'>Full Name</a></div>" +
        "<div class='pure-u-1-2 emailGreetingValue'>{RecipientInfo.DisplayName}</div>" +
        "<div class='pure-u-1-2'><a href='#' class='emailGreetingPlaceholder'>Email</a></div>" +
        "<div class='pure-u-1-2 emailGreetingValue'>{RecipientInfo.Email}</div>" +
        "</div>" +
        "</div>",

    initEmailGreetingHelp: function () {
        var greetingHelpEl = this.getElement("emailGreetingHelp");
        var greetingInputEl = this.getElement("emailGreetingInput");
        var greetingHelpContentEl = new Element("div", {
            "id": "emailGreetingHelpCont",
            "class": "emailGreetingHelpCont",
            "html": this.emailGreetingOptions
        });
        var bodyEl = $(document.body);
        bodyEl.grab(greetingHelpContentEl);
        greetingHelpContentEl.hide();

        if (greetingHelpEl) {
            greetingHelpEl.addOnClick(function (e) {
                e.stopPropagation();
                greetingHelpContentEl.show();

                greetingHelpContentEl.position({
                    relativeTo: greetingHelpEl,
                    edge: "upperLeft",
                    offset: {
                        x: 10
                    }
                });
            }.bind(this));
        }

        var placeHoldersEl = greetingHelpContentEl.getElements(".emailGreetingPlaceholder");
        placeHoldersEl.addOnClick(function (e) {
            var targetEl = e.target.getParent().getNext();
            var text = targetEl.get("text");

            var currentText = greetingInputEl.get("value");
            greetingInputEl.set("value", currentText + " " + text);
        });

        bodyEl.addOnClick(this.hideGreetingHelp);

        greetingHelpContentEl.addOnClick(function (e) {
            e.stopPropagation();
        });
    },

    hideGreetingHelp: function () {
        var greetingHelpEl = $("emailGreetingHelpCont");
        greetingHelpEl.hide();
    },

    onClose: function () {
        if (this.uploadWindow)
            this.uploadWindow.close();

        var greetingHelpEl = $("emailGreetingHelpCont");
        greetingHelpEl.destroy();

        $(document.body).removeEvent("click", this.hideGreetingHelp);
    }
});

Librarian.UserProfileWindow.extend({
    attributes: {}
})